/* eslint-disable import/no-extraneous-dependencies */
/* global React */
import { Box, Typography } from '@mui/material'
import { useStyles, useMemoRef } from '@platform/react/hook'
import { isStr } from 'lib/util'

const styles = (theme, { align, text }) => ({
  root: {
    width: '100%',
  },
  heading: {
    textAlign: align,
    whiteSpace: 'pre-line',
    marginBottom: '0.5rem',
  },
  shortTitle: {
    marginBottom: '0.5rem',
  },
  text: {
    whiteSpace: isStr(text) ? 'pre-line' : 'normal',
    textAlign: align,
  },
  ...theme.custom.prefaceText,
})

export const PrefaceText = ({ forwardedRef, ...props }) => {
  const {
    variant = {},
    gutterBottom = {},
    color = {},
    heading,
    label,
    shortTitle,
    text,
    value,
    align = 'left',
    classes: parentClasses = {},
  } = props

  const classes = useStyles(styles, { align, text })()
  return (
    <Box
      elevation={0}
      ref={forwardedRef}
      component={'header'}
      className={classes.root}
    >
      {shortTitle && (
        <Typography
          component={'p'}
          textTransform={'uppercase'}
          color={color.shortTitle || 'text.primary'}
          variant={variant.shortTitle || 'caption'}
          className={parentClasses.shortTitle || classes.shortTitle}
        >
          { shortTitle }
        </Typography>
      )}
      <Typography
        color={color.heading || 'black.main'}
        variant={variant.heading}
        className={parentClasses.heading || classes.heading}
        gutterBottom={gutterBottom.heading}
      >
        { heading || label }
      </Typography>
      <Typography
        component={isStr(text || value) ? 'p' : 'div'}
        color={color.text || 'text.primary'}
        variant={variant.text}
        className={parentClasses.text || classes.text}
        gutterBottom={gutterBottom.text}
      >
        { text || value }
      </Typography>
    </Box>
  )
}

export default useMemoRef(PrefaceText, props => [
  props.heading, props.label, props.text, props.value,
])
